export default "__VITE_ASSET__DNanZJMz__"